let globalStylesPromise: Promise<void> | null = null;

export const ensureGlobalStyles = (): Promise<void> => {
	if (globalStylesPromise) return globalStylesPromise;

	globalStylesPromise = import('@/styles/fullAppStyles')
		.then(() => undefined)
		.catch((error) => {
			globalStylesPromise = null;
			throw error;
		});

	return globalStylesPromise;
};
